import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  standardReturnsMessage: {
    description: 'Left navigation item that when clicked, shows the standard returns grid',
    defaultMessage: 'Standard Returns',
    id: '0WSdm4',
  },
  searchLabel: {
    defaultMessage: 'Returns Quicksearch',
    description: 'Label for returns search input',
    id: 'YplZwo',
  },
  searchPlaceholder: {
    defaultMessage: 'Search Returns...',
    description: 'placeholder text for returns search input',
    id: 'jSeU6P',
  },
});
